import Wind from "components/icons/Wind";

type TasksCardEmptyStateProps = {
  title: string;
  description: string;
};

export const TasksCardEmptyState = ({
  title,
  description,
}: TasksCardEmptyStateProps) => (
  <div className="t-flex t-h-full t-flex-col t-items-center t-justify-center t-gap-4 t-px-6 t-text-center">
    <Wind className="t-h-6 t-w-6 t-text-text-30" />
    <div className="t-flex t-flex-col t-items-center t-gap-2">
      <div className="t-text-subtext-sm t-text-text-30">{title}</div>
      <div className="t-max-w-[336px] t-text-body-sm-lite t-text-neutral-30">
        {description}
      </div>
    </div>
  </div>
);
